<div class="tw-flex tw-h-full tw-min-h-0 tw-flex-col">
  <h5 class="tw-m-0 tw-mb-4">配送センサーアラート</h5>
  <div class="tw-flex-1 tw-min-h-0 tw-overflow-y-auto">
    <mat-accordion multi>
      @if (alertList?.alertDetails) {
        <mat-expansion-panel
          [id]="alertList?.deviceName || alertList?.deviceId"
          [expanded]="true"
        >
          @for (
            alert of alertList?.alertDetails;
            track trackByAlert($index, alert)
          ) {
            <div [id]="createAlertId(alert)">
              @if (
                alert.status === "AlertMax" ||
                alert.status === "AlertMin" ||
                alert.status === "Alert"
              ) {
                <button
                  class="tw-w-full tw-border-0 tw-bg-red-100 tw-min-h-[55px] tw-px-3 tw-py-1 tw-text-left"
                  [ngClass]="{
                    'tw-font-bold tw-text-red-500': isSelectedAlert(alert),
                  }"
                  (mouseenter)="onMouseEnter($event)"
                  (mouseleave)="onMouseLeave($event)"
                  (click)="selectedAlert(alert)"
                >
                  <div class="tw-flex tw-items-center tw-gap-2">
                    <div class="tw-shrink-0 tw-leading-none">
                      <mat-icon>error</mat-icon>
                    </div>
                    <div
                      class="tw-flex tw-items-center tw-gap-1 tw-min-w-0 tw-flex-1"
                    >
                      @if (alert.status === "AlertMax") {
                        <div class="tw-min-w-[128px] tw-shrink-0">
                          {{ getSensorName(alert.sensor) }} 上限アラート:
                        </div>
                        <div class="tw-min-w-[80px] tw-shrink-0">
                          {{ alert.value | numeral: "0.0" }} {{ alert.unit }}
                        </div>
                        <div class="tw-min-w-[112px] tw-shrink-0">
                          （上限 {{ alert.threshold | numeral: "0.0" }}
                          {{ alert.unit }}）
                        </div>
                      } @else if (alert.status === "AlertMin") {
                        <div class="tw-min-w-[128px] tw-shrink-0">
                          {{ getSensorName(alert.sensor) }} 下限アラート:
                        </div>
                        <div class="tw-min-w-[80px] tw-shrink-0">
                          {{ alert.value | numeral: "0.0" }} {{ alert.unit }}
                        </div>
                        <div class="tw-min-w-[112px] tw-shrink-0">
                          （下限 {{ alert.threshold | numeral: "0.0" }}
                          {{ alert.unit }}）
                        </div>
                      } @else if (alert.sensor === "shockDetected") {
                        <!-- 衝撃検知の表示を変える -->
                        <div class="tw-min-w-[128px] tw-shrink-0">
                          {{ getSensorName(alert.sensor) }}アラート：
                        </div>
                        <div class="tw-min-w-[80px] tw-shrink-0">
                          （{{ alert.threshold ?? "-" }} G）
                        </div>
                        <div class="tw-min-w-[112px] tw-shrink-0"></div>
                      } @else if (alert.sensor === "lightExposure") {
                        <!-- 明暗検知の表示を変える -->
                        <div class="tw-min-w-[128px] tw-shrink-0">
                          {{
                            getSensorName(alert.sensor, alert.eventType)
                          }}アラート：
                        </div>
                        <div class="tw-min-w-[80px] tw-shrink-0">
                          （{{ alert.value ?? "-" }} Lux）
                        </div>
                        <div class="tw-min-w-[112px] tw-shrink-0"></div>
                      } @else {
                        <div class="tw-min-w-[128px] tw-shrink-0">
                          {{ getSensorName(alert.sensor, alert.eventType) }}
                          アラート
                        </div>
                        <div class="tw-min-w-[80px] tw-shrink-0"></div>
                        <div class="tw-min-w-[112px] tw-shrink-0"></div>
                      }
                    </div>

                    <div
                      class="tw-flex tw-flex-col tw-shrink-0 tw-w-[180px] tw-text-xs tw-leading-4 tw-whitespace-nowrap"
                    >
                      <div>
                        検知: {{ alert.eventAt | date: "yyyy/MM/dd HH:mm:ss" }}
                      </div>
                      <div>
                        通知:
                        {{ alert.reportedAt | date: "yyyy/MM/dd HH:mm:ss" }}
                      </div>
                    </div>
                  </div>
                </button>
              } @else if (
                alert.status === "PreAlertMax" ||
                alert.status === "PreAlertMin" ||
                alert.status === "PreAlert"
              ) {
                <button
                  class="tw-w-full tw-border-0 tw-bg-yellow-100 tw-min-h-[55px] tw-px-3 tw-py-1 tw-text-left"
                  [ngClass]="{
                    'tw-font-bold tw-text-red-500': isSelectedAlert(alert),
                  }"
                  (mouseenter)="onMouseEnter($event)"
                  (mouseleave)="onMouseLeave($event)"
                  (click)="selectedAlert(alert)"
                >
                  <div class="tw-flex tw-items-center tw-gap-2">
                    <div class="tw-shrink-0 tw-leading-none">
                      <mat-icon>warning</mat-icon>
                    </div>
                    <div
                      class="tw-flex tw-items-center tw-gap-1 tw-min-w-0 tw-flex-1"
                    >
                      @if (alert.status === "PreAlertMax") {
                        <div class="tw-min-w-[128px] tw-shrink-0">
                          {{ getSensorName(alert.sensor) }} 上限ワーニング:
                        </div>
                        <div class="tw-min-w-[80px] tw-shrink-0">
                          {{ alert.value | numeral: "0.0" }} {{ alert.unit }}
                        </div>
                        <div class="tw-min-w-[112px] tw-shrink-0">
                          （上限 {{ alert.threshold | numeral: "0.0" }}
                          {{ alert.unit }}）
                        </div>
                      } @else if (alert.status === "PreAlertMin") {
                        <div class="tw-min-w-[128px] tw-shrink-0">
                          {{ getSensorName(alert.sensor) }} 下限ワーニング:
                        </div>
                        <div class="tw-min-w-[80px] tw-shrink-0">
                          {{ alert.value | numeral: "0.0" }} {{ alert.unit }}
                        </div>
                        <div class="tw-min-w-[112px] tw-shrink-0">
                          （下限 {{ alert.threshold | numeral: "0.0" }}
                          {{ alert.unit }}）
                        </div>
                      } @else {
                        <div class="tw-min-w-[128px] tw-shrink-0">
                          {{ getSensorName(alert.sensor, alert.eventType) }}
                          ワーニング
                        </div>
                        <div class="tw-min-w-[80px] tw-shrink-0"></div>
                        <div class="tw-min-w-[112px] tw-shrink-0"></div>
                      }
                    </div>

                    <div
                      class="tw-flex tw-flex-col tw-shrink-0 tw-w-[180px] tw-text-xs tw-leading-4 tw-whitespace-nowrap"
                    >
                      <div>
                        検知: {{ alert.eventAt | date: "yyyy/MM/dd HH:mm:ss" }}
                      </div>
                      <div>
                        通知:
                        {{ alert.reportedAt | date: "yyyy/MM/dd HH:mm:ss" }}
                      </div>
                    </div>
                  </div>
                </button>
              }
            </div>
          }
        </mat-expansion-panel>
      }
    </mat-accordion>

    @if (!alertList?.alertDetails?.length) {
      <div>配送センサーアラートはありません。</div>
    }
  </div>
</div>
